<div class="wrapper">
    <div class="sidebar light-background-color" data-color="white">
        <app-sidebar-cmp></app-sidebar-cmp>
    </div>
    <div class="main-panel light-background-color" [ngClass]="isVenueBookingRecordPage?'active':''">
        <app-navbar-cmp></app-navbar-cmp>
        <router-outlet></router-outlet>
        <div *ngIf="!isMap()">
            <app-footer-cmp></app-footer-cmp>
        </div>
    </div>
</div>